/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from "react"
import ArtistsFilters from "../../Artists/Filters"
import ArtPieceFilters from "../../ArtPieces/Filters"
import ExhibitionFilters from "../../Exhibitions/Filters"
import SpaceFilters from "../../Spaces/Filters"

interface iProps {
  dataType?: string
  setQuery: (data: any, resetQuery?: boolean) => void
  query: any
}

const FeaturedFilters: FunctionComponent<iProps> = ({
  dataType,
  query,
  setQuery,
}) => {
  const props = {
    query,
    setQuery,
  }
  switch (dataType) {
    case "ArtPieces":
      return <ArtPieceFilters {...props} />
    case "Exhibitions":
      return <ExhibitionFilters {...props} />
    case "Artists":
      return <ArtistsFilters {...props} />
    case "Spaces":
      return <SpaceFilters {...props} />
    default:
      return null
  }
}

export default FeaturedFilters
